module.exports = __webpack_public_path__ + "static/media/i-am-3.2f007d79.jpeg";